module.exports = __webpack_public_path__ + "static/media/time.58a856d2.svg";